/* tslint:disable:directive-selector */
import { Directive, TemplateRef, ViewContainerRef, Input, OnDestroy } from '@angular/core';

import { UserService } from '../../services/user.service';
import { User } from '../../entities/index';


@Directive({
  selector: '[isSuperAdmin]'
})
export class IsSuperAdminDirective implements OnDestroy {
  protected subscription;
  private _previousIsSuperAdmin: boolean = null;

  constructor(
    private _viewContainer: ViewContainerRef,
    private _templateRef: TemplateRef<Object>,
    protected userService: UserService
  ) {
    this.watchCurrentUser();
  }

  watchCurrentUser() {
    this.subscription = this.userService.currentUser.subscribe(user => {
        if (this.isSuperAdminUser(user) && !this._previousIsSuperAdmin) {
          this._previousIsSuperAdmin = true;
          this._viewContainer.createEmbeddedView(this._templateRef);
        } else if (!this.isSuperAdminUser(user) && this._previousIsSuperAdmin) {
          this._previousIsSuperAdmin = false;
          this._viewContainer.clear();
        }
    });
  }

  protected isSuperAdminUser(user: User) {
      return user && user.is_admin && !user.role_retailer_id && !user.role_site;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /app/src/app/directives/permissions/is-super-admin.directive.ts